import React from 'react'

import { useTranslation } from 'react-i18next'

import { numAuthorizedPerformers } from '@models/util/product.util'
import { useTitle } from '@providers/TitleProvider'
import TitleService from '@services/TitleService'
import { useDialogStore } from '@stores/dialog.store'
import Tippy from '@tippyjs/react'

import DetailsSection from '../DetailsSection'
import PurchaseTitleDialog from '../purchase-title-dialog/PurchaseTitleDialog'

const AuthorizedPerformers: React.FC = () => {
  const { title } = useTitle()
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)

  const addMoreAuthorizedPerformers = () => openDialog('purchase_title_dialog')

  if (!title.isOwnedByUser()) return null
  return (
    <DetailsSection>
      <div className="flex justify-between">
        <Tippy
          arrow
          interactive
          placement="bottom"
          content={
            <button
              onClick={() => {
                TitleService.createEditableCopy(title.uuid)
              }}>
              {t('action.createEditableCopy')}
            </button>
          }
          trigger="click">
          <div className="flex cursor-pointer">
            <p className="text-md">
              <span className="font-medium">{t('content.authorizedPerformers.title')}</span>{' '}
              {numAuthorizedPerformers(title.product!, title.purchased_product!.purchased_quantity)}
            </p>
            <i className="text-xl pointer-events-none nf-icon nf-chevron-down" />
          </div>
        </Tippy>
        {!title.noMoreEnsemblesAvailable() && (
          <button className="p-0 orange-link link text-md" onClick={addMoreAuthorizedPerformers}>
            {t('action.addMore')}
          </button>
        )}
      </div>
      <PurchaseTitleDialog />
    </DetailsSection>
  )
}
export default AuthorizedPerformers
